import { Box, Card, LinearProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  exerciseSlide2,
  exerciseSlide3,
  exerciseSlide4,
  exerciseSlide5,
  exerciseSlide6,
  exerciseSlide7,
  exerciseSlide8,
  BackImg,
} from "@utils/defaultImages";
import Slider from "react-slick";
import ExerciseProgressBar from "@features/exercise/ExerciseProgressBar";
import { useTranslation } from "react-i18next";
import { useSocket } from "context/SocketContext";
import { useUI } from "context/LoadingContext";
const ExerciseGeneratingLoader = ({
  recreateLoading = false,
  handleFetchExercise,
  setGeneratePlanLoading,
  setTimeLeft,
  message,
  setMessage,
}) => {
  const { exerciseProgress, clearExerciseProgress } = useSocket();

  const [progress, setProgress] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const sliderRef = useRef();
  const videoRef = useRef();
  const { t } = useTranslation();
  const { setIsActionLocked } = useUI();

  const data = [
    t("exercisePlan.exerciseProgressLoader.link"),
    exerciseSlide2,
    exerciseSlide3,
    exerciseSlide4,
    exerciseSlide5,
    exerciseSlide6,
    exerciseSlide7,
    exerciseSlide8,
  ];
  useEffect(() => {
    if (currentSlide !== 0 && videoRef.current) {
      videoRef.current.pause();
      setIsVideoPlaying(false);
    }
  }, [currentSlide]);

  useEffect(() => {
    if (!exerciseProgress) return;

    if (exerciseProgress.progress === 100) {
      setProgress(100);
      setTimeout(() => {
        setTimeLeft(0);
        handleFetchExercise(true);
      }, 2000);
      clearExerciseProgress();
    }

    if (exerciseProgress.status === "in-progress") {
      setMessage(exerciseProgress.progress);
    }

    if (
      exerciseProgress.progress === 0 &&
      exerciseProgress.status === "failed"
    ) {
      setGeneratePlanLoading(false);
      clearExerciseProgress();
    }
  }, [exerciseProgress]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: !isVideoPlaying,
    autoplaySpeed: 15000,
    pauseOnHover: true,
    arrows: false,

    beforeChange: (current, next) => {
      setCurrentSlide(next);
      // Pause video when manually changing slides
      if (current === 0 && videoRef.current) {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      }
    },
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)", // Smoother transition
    appendDots: (dots) => (
      <div>
        <ul
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2px",
            listStyle: "none",
            margin: 0,
            padding: 0,
          }}
        >
          {React.Children.map(dots, (dot, index) =>
            React.cloneElement(dot, {
              style: {
                margin: 0,
                padding: 0,
                width: "12px",
                height: "12px",
              },
            })
          )}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: i === currentSlide ? "#0575E6" : "#fff",
          transition: "background-color 0.3s ease",
        }}
      />
    ),
  };

  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
    if (sliderRef.current) {
      sliderRef.current.slickPause();
    }
  };

  const handleVideoPause = () => {
    setIsVideoPlaying(false);
    if (sliderRef.current && currentSlide === 0) {
      sliderRef.current.slickPlay();
    }
  };

  const handleVideoEnd = () => {
    setIsVideoPlaying(false);
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  useEffect(() => {
    setIsActionLocked(true);
    return () => {
      setIsActionLocked(false);
    };
  }, []);

  return (
    <>
      <div className="flex justify-center items-start m-0">
        <Card
          className="px-6 pb-10 pt-6 md:p-6 md:pb-10 md:p-12 rounded-md w-full mb-5 bg-cover bg-center"
          style={{ backgroundImage: `url(${BackImg})` }}
        >
          <ExerciseProgressBar
            progress={progress}
            currentSlide={currentSlide}
            message={message}
          />
          {
            // !recreateLoading &&
            <Slider
              ref={sliderRef}
              {...settings}
              className={`max-w-[80vw] md:max-w-[unset] ${
                recreateLoading && "!hidden"
              } `}
            >
              {data.map((item, index) => {
                return (
                  <div
                    className="mt-[38px] rounded-lg !grid md:!grid-cols-2 min-h-[410px] xl:min-h-[458px] p-3 md:p-0"
                    key={index}
                  >
                    <div className="flex  w-full rounded-md overflow-hidden relative">
                      <div
                        className="w-[50%] hidden md:block"
                        // style={{
                        //   background:
                        //     "linear-gradient(159.42deg, #15AAFC 0%, #0771EF 107.62%)",
                        // }}
                      ></div>

                      {index === 0 ? (
                        <video
                          ref={videoRef}
                          className="object-contain bg-black md:transform md:-translate-y-1/2 rounded-md shadow-lg md:absolute md:left-[15%] md:top-[50%] w-full md:w-[80%] min-h-[240px] md:min-h-[300px] max-h-[371px]"
                          src={item}
                          autoPlay
                          playsInline
                          muted
                          controls
                          onPlay={handleVideoPlay}
                          onPause={handleVideoPause}
                          onEnded={handleVideoEnd}
                        />
                      ) : (
                        <img
                          className="rounded-md shadow-lg relative md:absolute md:left-[15%] top-[50%] w-full md:w-[80%] md:min-h-[300px] max-h-[371px] object-cover object-top"
                          style={{
                            transform: "translateY(-50%)",
                          }}
                          src={item}
                        />
                      )}
                    </div>
                    <div className="flex items-center md:px-[20px]">
                      <div>
                        <h1 className="text-[16px] lg:text-[20px] xl:text-[28px] font-[700] text-[#fff] font-[Lato] mb-3 lg:mb-4 break-words hyphens-auto">
                          {t(
                            `exercisePlan.exerciseProgressLoader.slides.${index}.heading`
                          )}
                        </h1>

                        <h2 className="text-[#fff] font-[400] font-[Lato] text-[12px] lg:text-[16px] xl:text-[20px] mb-3 lg:mb-6 break-words hyphens-auto">
                          {t(
                            `exercisePlan.exerciseProgressLoader.slides.${index}.subheading`
                          )}
                        </h2>

                        <p className="text-[12px] xl:text-[18px] font-[400] text-[#fff] font-[Lato] break-words hyphens-auto leading-relaxed">
                          {t(
                            `exercisePlan.exerciseProgressLoader.slides.${index}.description`
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          }
        </Card>
      </div>
    </>
  );
};
export default ExerciseGeneratingLoader;
